<main role="main" class="not-home-page">
  <div class="row">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="banner"><img src="" alt="" /></div>
          <app-breadcrumb></app-breadcrumb>
          <h2>{{ description?.Title }}</h2>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-s-12">
            <nav id="sidebar">
              <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
            </nav>
          </div>
          <div class="col-lg-9 col-md-9 col-s-12">

            <p class="text-primary size18 font-weight-semibold">
              {{ description?.Contenu }}
            </p>

            <div *ngFor="let item of datacocurrences">
              <div class="block-appels d-flex align-items-start flex-column">
                <div class="d-flex justify-content-between w-100">

                  <h3 *ngIf="isArab; else TitleFr" class="num-appel-offre"> إعلان عن طلب منافسة رقم : {{ item.Title }}</h3>
                  <ng-template #TitleFr>
                    <h3  class="num-appel-offre">Avis d'appel à la concurrence N° :{{ item.Title }}</h3>
                  </ng-template>
                  <div class="date-appels mt-auto" style="width: 100%; max-width: fit-content">
                    {{ converteDate(item.Date_x0020_Publication )}}
                  </div>
                </div>
                <p *ngIf="isArab; else notArab">{{ item.Objet_ar }}</p>
                <ng-template #notArab>
                  <p class="titre-appels">{{ item.Objet }}</p>
                </ng-template>


                <p>
                 <strong> {{"concurrence.telecharger" | translate}}</strong>
                  <span *ngFor="let link of item.AttachmentFiles">
                    <a *ngIf="
                        link.FileName.toLowerCase().includes('_fr') &&
                        !link.FileName.toLowerCase().includes('annulation')&&
                        !link.FileName.toLowerCase().includes('report')
                      " href="{{ link.ServerRelativeUrl }}"> {{"concurrence.fr" | translate}} </a>
                    <a *ngIf="
                        link.FileName.toLowerCase().includes('_ar')&&
                        !link.FileName.toLowerCase().includes('annulation')&&
                        !link.FileName.toLowerCase().includes('report')
                      " href="{{ link.ServerRelativeUrl }}"> {{"concurrence.ar" | translate}} </a>
                  </span>
                </p>
                <p *ngIf="hasReportFile(item.AttachmentFiles)">
                  <strong> {{"concurrence.report" | translate}} </strong>
                  <span *ngFor="let link of item.AttachmentFiles">
                    <a *ngIf="
                        link.FileName.toLowerCase().includes('_fr') &&
                        !link.FileName.toLowerCase().includes('annulation')&&
                        link.FileName.toLowerCase().includes('report')
                      " href="{{ link.ServerRelativeUrl }}" > {{"concurrence.fr" | translate}} </a>
                    <a *ngIf="
                        link.FileName.toLowerCase().includes('_ar')&&
                        !link.FileName.toLowerCase().includes('annulation')&&
                        link.FileName.toLowerCase().includes('report')
                      " href="{{ link.ServerRelativeUrl }}"> {{"concurrence.ar" | translate}} </a>
                  </span>
               </p>
                <p *ngIf="hasannulationFile(item.AttachmentFiles)">
                  <strong> {{"concurrence.annulation" | translate}} </strong>
                  <span *ngFor="let link of item.AttachmentFiles">
                    <a *ngIf="
                        link.FileName.toLowerCase().includes('_fr') &&
                        link.FileName.toLowerCase().includes('annulation')&&
                        !link.FileName.toLowerCase().includes('report')
                      " href="{{ link.ServerRelativeUrl }}">  {{"concurrence.fr" | translate}} </a>
                    <a *ngIf="
                        link.FileName.toLowerCase().includes('_ar')&&
                        link.FileName.toLowerCase().includes('annulation')&&
                        !link.FileName.toLowerCase().includes('report')
                      " href="{{ link.ServerRelativeUrl }}"> {{"concurrence.ar" | translate}} </a>
                  </span>
               </p>
                <!-- <ul>
                            <li *ngFor="let link of item.AttachmentFiles"> <a href="{{link.ServerRelativeUrl}}">{{link.FileName}}</a></li>
                        </ul> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>